/*
 * @Descripttion:
 * @version:
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-06-15 13:44:35
 * @LastEditors: linxi
 * @LastEditTime: 2023-07-31 10:21:29
 */
import { unwrapResult } from '@reduxjs/toolkit'
import {
  Checkbox,
  Col,
  Form,
  Input,
  Modal,
  ModalProps,
  Row,
  Select,
} from 'antd'
import React, { ReactElement, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import {
  getPayListYinlian,
  savePayListYinlian
} from './TenentSettingSlice'
import { getTenantDetail } from '../tenantSlice'

const { Option } = Select
export interface SettingProps {
  tenantId: string
  id?: number
}

export const TenentSettingPayModalYinlian = ({
  id,
  tenantId,
  onOk,
  onCancel,
  visible,
}: ModalProps & SettingProps): ReactElement => {
  const dispatch = useDispatch<any>()
  const [form] = Form.useForm()

  const [status, setStatus] = useState(true)

  const [tenant, setTenant] = useState<any>()


  const mastRule = [
    {
      required: true,
    },
  ]
  const layout = {
    labelCol: { span: 12 },
    wrapperCol: { span: 12 },
  }

  const FormatLayout = {
    labelCol: { span: 6 },
    wrapperCol: { span: 18 },
  }
  const SelectLayout = {
    labelCol: { span: 8 },
    wrapperCol: { span: 18 },
  }


  useEffect(() => {

    // 数据回显
    if (id === 0) {
      // 数据回显
      dispatch(getPayListYinlian(tenantId))
        .then(unwrapResult)
        .then((res: any) => {
          if (res.openHubPayYinlian === 0) {
            setStatus(false)
          } else {
            setStatus(true)
          }
          form.setFieldsValue({
            ...res.chlYinlianVO
          })
        })

    }
    // 获取机构名称
    dispatch(getTenantDetail(tenantId))
      .then(unwrapResult)
      .then((tenant: any) => {
        setTenant(tenant)
        form.setFieldsValue({
          tenantName: tenant.name,
          male: '银联'
        })
      })
    return () => {
      form.resetFields()
    }
  }, [visible])

  useEffect(() => {
    if (!visible) {
      form.resetFields()
    }
  }, [visible])

  return (
    <Modal
      title={'聚合支付（银联）'}
      visible={visible}
      width='900px'
      onOk={() => {
        form.submit()
      }}
      onCancel={onCancel}
    >
      <Form
        {...layout}
        form={form}
        onFinish={async (vs) => {
          await dispatch(
            savePayListYinlian({
              openHubPayYinlian: status ? 1 : 0,
              chlYinlianVO: {
                ...vs,
                tenantId,
              }
            })
          )
            .then(unwrapResult)
            .then(onOk)

        }}
      >

        <Row gutter={20}>
          <Col span={12}>
            <Form.Item name='tenantName' label='机构名称' required {...FormatLayout}>
              <Input disabled />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='male' label='供应商名称' {...SelectLayout} rules={mastRule}>
              <Select>
                <Option value="male">银联</Option>
              </Select>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={12}>
            <Form.Item name='merchantCode' label='商户号' rules={mastRule} {...FormatLayout}>
              <Input />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item name='terminalCode' label='终端号' rules={mastRule} {...SelectLayout}>
              <Input   />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={20}>
          <Col span={8}>
            <Form.Item label='是否启用'>
              <Checkbox
                checked={status}
                onChange={() => {
                  setStatus(!status)
                }}
              >
                启用
              </Checkbox>
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal >
  )
}
